<template>
  <div>
    <el-card shadow="always">
      <el-page-header v-if="id === ''" @back="back" title :content="$t('adicionar-nova-embalagem')"></el-page-header>
      <el-page-header v-if="id !== ''" @back="back" title :content="$t('atualizar-embalagem')"></el-page-header>
    </el-card>
    <el-card>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top">
        <el-row :gutter="5">
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-if="user.type !== '5' && !id">
            <el-form-item :label="user.type === '1' || user.type === '3' ? $t('cliente') : $t('filial')" prop="customer">
              <CustomerList v-model="ruleForm.customer" v-bind:customerType="user.type === '2' ? 3 : 1"
                v-bind:current="ruleForm.customer" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('codigo')" prop="code">
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-input ref="code" maxlength="30" :disabled="id !== ''" v-model="ruleForm.code"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item :label="$t('nome')" prop="name">
          <el-input ref="name" v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-if="user.type === '1'">
            <el-form-item :label="$t('tipo')" prop="type">
              <el-select v-model="ruleForm.type" :placeholder="$t('selecione-uma-opcao')">
                <el-option key="1" label="Pré-postagem" value="1"></el-option>
                <el-option key="2" label="Logistica Reversa" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6" v-if="ruleForm.type === '2'">
            <el-form-item :label="$t('tipo-embalagem')" prop="packingType">
              <el-select v-model="ruleForm.packingType" :placeholder="$t('selecione-uma-opcao')">
                <el-option key="0" label="0" value="0"></el-option>
                <el-option key="2" label="2" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6" v-if="user.type === '1'">
            <el-form-item :label="$t('valor')" prop="value">
              <el-input type="number" style="width: 250px;"
                pattern="^\\$?(([1-9](\\d*|\\d{0,2}(,\\d{3})*))|0)(\\.\\d{1,2})?$" :controls="false" :min="0" :max="max"
                v-model="ruleForm.value" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('altura')" prop="height">
          <el-input-number size="small" v-model="ruleForm.heightmin"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('largura')" prop="width">
          <el-input-number size="small" v-model="ruleForm.widthmin"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('comprimento')" prop="length">
          <el-input-number size="small" v-model="ruleForm.lengthmin"></el-input-number>
        </el-form-item>
        <br />
        <el-form-item>
          <el-button type="warning" v-if="id === ''" autofocus @click="submitForm('ruleForm')">{{ $t("adicionar")
          }}</el-button>
          <el-button type="warning" v-if="id !== ''" autofocus @click="editForm('ruleForm')">{{ $t("atualizar")
          }}</el-button>
          <el-button @click="back()">{{ $t("voltar") }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template> 
<script>
import { PackingService } from "@/services/customers/packing.services";
import { i18n } from "@/plugin/i18n";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import { UserService } from "@/services/users/user.services";

export default {
  name: "PackingAdd",
  components: {
    CustomerList,
  },
  data() {
    return {
      id: "",
      user: { type: "2'" },
      ruleForm: {
        name: "",
        code: "",
        type: '1',
        value: 0,
        packingType: '0',
        customer: "",
        lengthmin: 0,
        lengthmax: 0,
        widthmin: 0,
        widthmax: 0,
        heightmin: 0,
        heightmax: 0,
      },
      rules: {
        name: [
          {
            required: true,
            message: i18n.tc("nome-obrigatorio"),
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: i18n.tc("codigo-obrigatorio"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    back() {
      var vm = this;
      vm.$router.push("/cadastro/embalagem").catch(() => { });
    },
    get() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      PackingService.get(vm.id)
        .then((response) => {
          vm.ruleForm = response;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    submitForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);
          PackingService.add(vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("embalagem-adicionado-sucesso"),
              });
              this.$refs[formName].resetFields();
            })
            .catch((error) => {
              this.$message({
                dangerouslyUseHTMLString: true,
                duration: 5000,
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    editForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);
          PackingService.update(vm.id, vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("embalagem-atualizado-sucesso"),
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
        if (this.$route.params.id) {
          this.id = this.$route.params.id;
          vm.get();
        } else {
          vm.$refs.code.$el.children[0].focus();
        }
      })
      .catch((error) => {
        vm.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}

form {
  margin-top: 20px;
}

@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}
</style>
